import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import ResponsivePagination from 'react-responsive-pagination';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { set } from 'date-fns';
import CurrencyFormat from 'react-currency-format';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../../Config/formatDate';

const filterTypes = [
    { name: "All", value: "" },
    { name: "Created", value: "created" },
    { name: "Used", value: "used" },
    { name: "Redeemed", value: "redeemed" },
    { name: "Expired", value: "expired" }
]
const filterTypes2 = [
    { name: "All", value: "" },
    { name: "Activated", value: true },
    { name: "Deactivated", value: false },
]

export default function Coupons() {
    const dataval = useSelector((state) => state.dataValue)
    const searchParams = new URLSearchParams(window.location.search)
    let navigate = useNavigate()
    const location = useLocation()
    const valueInt = {
        title: '',
        value: '',
        units: 1,
    }
    const [loading, setloading] = useState(true)
    const [value, setvalue] = useState(valueInt)
    const [list, setlist] = useState([])
    const [selectAll, setselectAll] = useState(false)

    let limit = 20
    const [params, setParams] = useState({
        // sort_key: searchParams.get("sort_key") || "",
        // sort_value: searchParams.get("sort_value") || "asc",
        search: searchParams.get("search") || "",
        page: searchParams.get("page") || 1,
        status: searchParams.get("status") || "",
    })
    const [count, setCount] = useState(1)
    const [searchProgress, setsearchProgress] = useState(false)
    const [showAddvoucher, setshowAddvoucher] = useState(false)


    const setparam = (key, val) => {
        searchParams.set(key, val)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }
    const deleteparam = (key) => {
        searchParams.delete(key)
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
    }
    const [search, setsearch] = useState(searchParams.get("search") || "")
    const searchUser = (e) => {
        deleteparam("page")
        setsearch(e.target.value)
        if (e.target.value == "") {
            setParams({ ...params, 'page': 1, 'search': "" })
            deleteparam("search")
        } else {
            setparam("search", e.target.value)
        }
    }
    useEffect(() => {
        // deleteparam("page")
        const delayDebounceFn = setTimeout(() => {
            if (search != "") {
                setsearchProgress(true)
                setParams({ ...params, page: 1, search: search })
                setparam('search', search)
            }

        }, 1000)

        return () => clearTimeout(delayDebounceFn)
    }, [search])

    const onSelectChange = (e) => {
        if (e.target.value) {
            setParams({ ...params, [e.target.name]: e.target.value, page: 1 })
            setparam([e.target.name], e.target.value)
            setparam("page", 1)
        } else {
            setParams({ ...params, [e.target.name]: "", page: 1 })
            deleteparam(e.target.name)
        }
    }
    const onPageChangeFunction = (number) => {
        if (number !== parseInt(params.page)) {
            setParams({ ...params, page: number })
            setparam("page", number)
            setloading(true)
        } else {
            setparam("page", number)
            setParams({ ...params, page: number })
        }
    }
    const clearFilter = () => {
        setParams({
            ...params,
            sort_key: "",
            sort_value: "asc",
        })
        deleteparam("sort_key")
        deleteparam("sort_value")
    }
    const clearSearch = () => {
        setParams({
            ...params,
            search: "",
        })
        setsearch("")
        deleteparam("search")
        setsearchProgress(true)
    }
    // getVoucherList
    const getVoucherList = (param) => {
        Api.GetApi(`${endPoints.GETVOUCHERLIST}${param}`, "").then(res => {
            setsearchProgress(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                let result = res.data?.data[0]?.result.map((data) => ({ ...data, checked: false }))
                setlist(result || [])
                let newCount = Math.ceil(parseInt(res.data?.data[0]?.totalCount?.count) / limit)
                if (newCount !== 0) {
                    let items = [];
                    for (let number = 1; number <= newCount; number++) {
                        items.push(number);
                    }
                    setCount(items)
                } else {
                    setCount(1)
                }
            }
        })
    }

    const handleInputchange = (e) => {
        setvalue({ ...value, [e.target.name]: e.target.value.replace(/^\s+/, '') })
    }

    const handleQty = (type) => {
        if (type == "inc") {
            if (value.units < 20) {
                setvalue({ ...value, units: value.units + 1 })
            }
        } else {
            if (value.units > 1) {
                setvalue({ ...value, units: value.units - 1 })
            }
        }
    }

    const handleQtychange = (e) => {
        if (Number(e.target.value) > 0 && Number(e.target.value) < 21) {
            setvalue({ ...value, units: Number(e.target.value) })
        }
    }

    const createVoucher = () => {
        if (value.title == "") {
            Api.Alert("Please enter valid title", "error")
            return
        }
        if (value.value == "" || Number(value.value) == 0 || value.units == "") {
            Api.Alert("Please enter valid amount", "error")
            return
        }
        let body = {
            ...value
        }
        console.log("body", body)
        Api.PostApi(endPoints.ADMINVOUCHER, body).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                Api.Alert(res.data.data, "success")
                setvalue(valueInt)
                setshowAddvoucher(false)
                getVoucherList(location.search)
            }
        })
    }
    const activateVoucher = (val) => {
        let body = {
            "ids": list.filter((data) => data.checked == true).map((data) => data._id),
            "action": val
        }
        console.log("body", body)
        Api.PostApi(endPoints.VOUCHERACTION, body).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                Api.Alert(res.data.data, "success")
                getVoucherList(location.search)
            }
        })
    }

    const handleCheckBoxChange = (e, id) => {
        let arr = list.map((data) => {
            if (id == "all") {
                data.checked = e.target.checked
            } else {
                if (data._id == id) {
                    data.checked = e.target.checked
                }
            }
            return data
        })
        setlist(arr)
    }

    const onActiveChange = (e) => {
        activateVoucher(e.target.value)
    }

    useEffect(() => {
        // if (!searchParams.get("sort_key")) {
        //     clearFilter()
        // }
        // if (!searchParams.get("search")) {
        //     console.log("search lebnth1 true", searchParams.get("search"))
        //     // clearSearch()
        // }
        // if (searchParams.get("page") && searchParams.get("page") != params.page) {
        //     setParams({ ...params, page: searchParams.get("page") })
        // }
        console.log("searchParams.get", searchParams.get("sort_key"))
        const to = { pathname: location.pathname, search: searchParams.toString() };
        navigate(to, { replace: true });
        getVoucherList(location.search)
    }, [params])

    console.log("list", list)
    console.log("value", value)


    return (
        <main id="main" className="main">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>Reward Coupons</h1>
                <div className='text-end'>
                    <button className='btn btn-primary btn-md' onClick={() => setshowAddvoucher(true)}>+ Create Reward Coupon</button>
                </div>
            </div>
            {loading ?
                <div className="loader-line"></div> :
                <div className="row">
                    {showAddvoucher ?
                        <div className="col-12 col-lg-8 col-xxl-12">
                            <div className="card">
                                <div className="card-body py-3">
                                    <h5 className='card-title pb-0 mb-3'>Create Reward Coupon</h5>
                                    <div className='row align-items-end'>
                                        <div className='col-md-2 mb-3 mb-md-0'>
                                            <label className='mb-2'>Title</label>
                                            <input type="text" name="title" placeholder='Enter title' className="form-control" onChange={handleInputchange} autoComplete='off' value={value?.title} maxLength="50" />
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='d-flex gap-3'>
                                                <div className=''>
                                                    <label className='mb-2'>Number of Coupons</label>
                                                    <div className='coupon_qty_block'>
                                                        <button className='btn btn-danger' onClick={() => handleQty("dec")}>-</button>
                                                        <input type="number" name="units" className="form-control" onChange={handleQtychange} autoComplete='off' value={value?.units} />
                                                        <button className='btn btn-primary' onClick={() => handleQty("inc")}>+</button>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    <label className='mb-2'>Amount(RM)</label>
                                                    <input type="text" name="value" placeholder='0.00' className="form-control" onChange={handleInputchange} autoComplete='off' value={value?.value} maxLength="10" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <label className='mb-2'>&nbsp;</label>
                                            <div className='d-flex gap-3'>
                                                <button className='btn btn-primary btn-md' onClick={createVoucher}>Submit</button>
                                                <button className='btn btn-outline-danger btn-md' onClick={() => setshowAddvoucher(false)}>Dismiss</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        : null
                    }
                    <div className='col-12'>
                        <div className="card">
                            <div className="card-body py-3">
                                <div className="d-flex mb-0 mb-md-2 justify-content-between align-items-center userdetailTopRow ">
                                    <div className='userdetailTopRow__left col-12 col-md-5'>
                                        <div className="d-flex align-items-start align-items-sm-center  mb-3 mb-md-2 flex-column flex-sm-row  " >
                                            <div className="search-bar pe-1  ">
                                                <div className="search-form d-flex align-items-center" >
                                                    <input type="text" className='form-control'
                                                        name="search" placeholder="Search by coupon code" value={search} title="Enter search keyword" onChange={searchUser} autoComplete="off" disabled={searchProgress} />
                                                    <span className="searchBarIcon" title="Search"><Icon.Search /></span>
                                                </div>
                                            </div>
                                            {search !== "" ?
                                                <button type="button" disabled={searchProgress} className="textClear nowrap " style={{ opacity: searchProgress ? "0" : "1" }} onClick={clearSearch}>Clear Search</button> : null
                                            }
                                        </div>
                                    </div>

                                    <div className=" d-md-flex align-items-center userdetailTopRow__right userdetailTopRow__right--sessionpage" >
                                        <div className='my-2 d-flex flex-wrap'>
                                            <select className='sortingSelect' name='active' value={params.active} onChange={onSelectChange}>
                                                {/* <option disabled defaultValue value="">Filter By</option> */}
                                                {filterTypes2.map((data, index) => {
                                                    return (
                                                        <option key={index} value={data.value}>{data.name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                        <div className='my-2 d-flex flex-wrap ms-4'>
                                            <label className='me-2'>Status: </label>
                                            <select className='sortingSelect' name='status' value={params.status} onChange={onSelectChange}>
                                                {/* <option disabled defaultValue value="">Filter By</option> */}
                                                {filterTypes.map((data, index) => {
                                                    return (
                                                        <option key={index} value={data.value}>{data.name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                {list && list.length > 0 ?
                                    <>
                                        <div className="table-responsive">
                                            <table className='table dataTable'>
                                                <thead>
                                                    <tr>
                                                        <th width="20">
                                                            <Form.Check
                                                                type={"checkbox"}
                                                                id={"selectall"}
                                                                name='select'
                                                                label={""}
                                                                checked={list.filter((x) => x?.checked).length == list.length}
                                                                onChange={(e) => handleCheckBoxChange(e, "all")}
                                                            />
                                                        </th>
                                                        <th width="150">
                                                            {
                                                                list.filter((x) => x?.checked).length ? <select className='sortingSelect' name='status' onChange={onActiveChange}>
                                                                    <option value={""}>Select Action</option>
                                                                    <option value={"activate"}>Activate</option>
                                                                    <option value={"deactivate"}>Deactivate</option>
                                                                </select> : "Code"
                                                            }
                                                        </th>
                                                        <th>Title</th>
                                                        <th>User</th>
                                                        <th>Created at</th>
                                                        <th>Redeemed at</th>
                                                        <th>Expired at</th>
                                                        <th>Value</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map((data, indx) => {
                                                        return (
                                                            <tr key={indx}>
                                                                <td>
                                                                    <Form.Check
                                                                        type={"checkbox"}
                                                                        id={"selectall"}
                                                                        name='select'
                                                                        label={""}
                                                                        checked={data.checked}
                                                                        onChange={(e) => handleCheckBoxChange(e, data?._id)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <strong class={`dot ${data.is_active ? "online" : "offline"}`} title="Online">{data?.code || "-"}</strong>
                                                                    {/* <small className={`ms-3 badge ${data?.is_active ? "bg-success" : "bg-danger"}`}>{data?.is_active ? "Active" : "Inactive"}</small> */}
                                                                </td>
                                                                <td>{data?.title || "-"}</td>
                                                                <td className='fixedWidth'>
                                                                    {data?.user ?
                                                                        <>
                                                                            <Link to={`/users/${data?.user?._id}`}>
                                                                                <strong>{data?.user?.first_name ? `${data?.user?.first_name} ${data?.user?.last_name}` : ""}</strong>
                                                                            </Link>
                                                                            <p className='mb-0'>{data?.user?.email || ""}</p>
                                                                            <p>{data?.user?.country_code ? `${data?.user?.country_code.includes("+") ? "" : "+"}${data?.user?.country_code}` : ""} {data?.user?.phone_number || ""}</p>
                                                                        </>
                                                                        : "-"
                                                                    }
                                                                </td>
                                                                <td>{formatDate(data?.createdAt) || "-"}</td>
                                                                <td>{data?.redeemed_at ? formatDate(data?.redeemed_at, "ll") : "-"}</td>
                                                                <td>{data?.expire_by ? formatDate(data?.expire_by, "ll") : "-"}</td>
                                                                <td><CurrencyFormat value={parseFloat(data?.value || "0").toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'RM'} /></td>
                                                                <td style={{ textTransform: "capitalize" }}><span className={`badge ${data?.status == "created" ? "bg-secondary" : data?.status == "used" ? "bg-warning" : data?.status == "expired" ? "bg-danger" : "bg-success"}`}>{data?.status}</span></td>
                                                            </tr>)
                                                    })}

                                                </tbody>
                                            </table>

                                        </div></>
                                    :


                                    <div className='text-center py-5'>
                                        <h3>No result found</h3>
                                    </div>
                                }
                                <div style={{ maxWidth: "500px" }}>
                                    {searchProgress ?
                                        <div className='loadingTd' style={{ maxWidth: "100px" }}><div className='bar'></div>
                                        </div> :
                                        <ResponsivePagination
                                            current={parseFloat(searchParams.get("page"))}
                                            total={count.length}
                                            onPageChange={onPageChangeFunction}
                                            disabled={params.page === count.length}
                                            // maxWidth={500}
                                            className={"pagination "}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }


        </main >
    )
}
